import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollSmoother from 'gsap/ScrollSmoother'
import Observer from 'gsap/Observer'
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, Observer)

ScrollTrigger.config({
  limitCallbacks: true,
  ignoreMobileResize: true
})

export * from 'gsap'
export * from 'gsap/ScrollTrigger'
export * from 'gsap/ScrollSmoother'
export * from 'gsap/Observer'
